import { Metamodel } from 'app/model/base/model';
import { IAttribute } from 'app/model/base/annotation';
import { StoreSettingMetadata } from 'shell-models-lib';
import { validateMetadataContent } from 'app/shared/utils/store-settings-validation.util';
import { StoreWriteSettings } from './store-write-settings';

@Metamodel.model({
    abstract: true
})
export abstract class AdvancedStoreWriteSettings extends StoreWriteSettings {
    public static readonly BLOCK_SIZE: IAttribute;
    public static readonly METADATA: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'BLOCK_SIZE',
        display: stringResources.ModelName_BlockSizeInMB
    })
    public blockSizeInMB?: number;

    @Metamodel.attribute({
        display: stringResources.Metadata,
        association: 'METADATA',
        templatable: true,
        defaultValue: [],
        constraint: {
            validator: validateMetadataContent
        }
    })
    public metadata?: StoreSettingMetadata[] = [];

    public recoverPropFromPrevOne(prevStoreSettings: AdvancedStoreWriteSettings): void {
        if (prevStoreSettings) {
            super.recoverPropFromPrevOne(prevStoreSettings);
            this.blockSizeInMB = prevStoreSettings.blockSizeInMB;
            this.metadata = prevStoreSettings.metadata;
        }
    }
}
